'use strict';

let calcApplyOffsetMargin = function(container) {
	let info = document.querySelector('.text-image-overlay-layout__info');
	let infoHeight = info.offsetHeight;
	let imageHeight = document.querySelector('.text-image-overlay-layout__img-cell').offsetHeight;

	let offset = infoHeight / 2;
	if (imageHeight < infoHeight) {
		offset = imageHeight / 2;
	}

	container.style.marginBottom = "-" + offset + "px";
	info.style.transform = `translate(0px, -${offset}px)`;
}

let init = function() {
	let container = document.querySelector('.text-image-overlay-layout--bottom');
	if (document.body.contains(container)) {

		calcApplyOffsetMargin(container);

	}
}

module.exports = {
	init: init
};